import { render, staticRenderFns } from "./VeryLowActivity.vue?vue&type=template&id=a4333cd2&"
import script from "./VeryLowActivity.vue?vue&type=script&lang=js&"
export * from "./VeryLowActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports